import React from 'react'

import { StyleSheet, View } from 'react-native'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { SafeAreaView } from 'react-native-safe-area-context'

import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import {
  Title,
  Button,
  Description,
  Space
} from '@sart/components'
import { CompanyIcon } from '@sart/icons'

import NeedHelpFooter from './NeedHelpFooter'

export default function Welcome(props) {
  const { navigation } = props

  const content = useContent()

  async function handleFistVisit() {
    try {
      await AsyncStorage.setItem('visitedBefore', 'true')

      navigation.navigate('Sign', { screen: 'SignIn' })
    } catch (error) { }
  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.wrapper}>
        <View style={styles.logo}>
          <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} />
        </View>
        <Space height={48} />

        <Title style={styles.title}>{content.registerHome.title}</Title>

        <Space height={24} />

        <Description style={styles.description}>
          {content.welcome.instructions}
        </Description>

        <Space height={48} />

        <Button
          title={content.welcome.action}
          onPress={handleFistVisit}
          style={styles.button}
          titleStyle={{ ...typography.extrabold, fontSize: 18 }}
        />
      </View>

    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: backgroundColors.srGreen
  },
  wrapper: {
    flex: 1,
    ...adaptive.wrapperPadding,
    justifyContent: 'center'
  },
  logo: {
    alignSelf: 'center'
  },
  title: {
    color: colors.clear,
    ...typography.bold
  },
  button: {
    backgroundColor: backgroundColors.srDarkGreen
  },
  description: {
    textAlign: 'center',
    color: colors.white,
    ...typography.demi,
  },
  logoStyle: {
    ...adaptive.guruSize
  },
})
